import { render, staticRenderFns } from "./warning-manage-list.vue?vue&type=template&id=0cddbc0d&scoped=true&"
import script from "./warning-manage-list.vue?vue&type=script&lang=js&"
export * from "./warning-manage-list.vue?vue&type=script&lang=js&"
import style0 from "./warning-manage-list.vue?vue&type=style&index=0&id=0cddbc0d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cddbc0d",
  null
  
)

export default component.exports